// Model.js
// -----------------------
// @module Case
define("DC.PDPSpecificationTab.PDPSpecificationExt.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        
        
});
});
